import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';
import { Material, MaterialDto, MaterialType, MaterialTypeDto } from '../models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getMaterialTypes(): Observable<MaterialType[]> {
        return this.httpClient
            .get<ApiResponse<MaterialTypeDto[]>>('v1/admin/material-types')
            .pipe(mapDto((response) => response.data.map((dto) => new MaterialType(dto))));
    }

    getMaterials(id: string): Observable<Material[]> {
        return this.httpClient
            .get<ApiResponse<MaterialDto[]>>(`v1/admin/material-types/${id}/materials`)
            .pipe(mapDto((response) => response.data.map((dto) => new Material(dto))));
    }
}
